import { render, staticRenderFns } from "./LazyPhoto.vue?vue&type=template&id=312645a6&scoped=true"
import script from "./LazyPhoto.vue?vue&type=script&lang=js"
export * from "./LazyPhoto.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./LazyPhoto.vue?vue&type=style&index=0&id=312645a6&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./LazyPhoto.vue?vue&type=style&index=1&id=312645a6&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "312645a6",
  "6fb46053"
  
)

export default component.exports